import { isArray } from "lodash";
import axiosConfig from "../../../config/axiosConfig";
import {
  ADD_COLUMN_PREFERENCES_URL,
  BAM_USERS_URL,
  CONFIG_VENDOR_URL,
  CUSTOMER_PN_DROPDOWN_URL,
  DELETE_ATTACHEMENTS_URL,
  GET_CONSTANTS_URL,
  GET_FAMILIES__TYPES_URL,
  GET_FAMILIES__URL,
  GET_FILTER_DROPDOWN_URL,
  GET_GENERAL_COLUMN_PREFERENCES_URL,
  PN_DROPDOWN_URL,
  RV_DROPDOWN_URL,
  UPDATE_COLUMN_PREFERENCES_URL,
} from "../../../config/config";
import { createQueryParams, getStringFromArray } from "../../../utils/helper";

export const GetFilterDropdownService = async (params) => {
  const { module_name } = params;
  return axiosConfig.get(
    `${GET_FILTER_DROPDOWN_URL}?module_name=${module_name}`
  );
};

export const GetGeneralColumnPreferencesService = (params) => {
  return axiosConfig.get(`${GET_GENERAL_COLUMN_PREFERENCES_URL}`);
};

export const AddColumnPreferencesService = (data) => {
  return axiosConfig.post(ADD_COLUMN_PREFERENCES_URL, data);
};

export const GetColumnPreferencesService = (data) => {
  return axiosConfig.get(GET_GENERAL_COLUMN_PREFERENCES_URL, data);
};

export const UpdateColumnPreferencesService = (params) => {
  const { id, filed, module_name } = params;
  return axiosConfig.put(`${UPDATE_COLUMN_PREFERENCES_URL}/${id}/`, {
    module_name: module_name,
    column_preferences: filed,
  });
};

// asset dropdowns

export const GetConstantsService = async (params) => {
  const { constant_types } = params;
  return axiosConfig.get(
    `${GET_CONSTANTS_URL}?constant_types=${constant_types}`
  );
};

// asset families

export const GetAircraftFamilyService = async (params) => {
  const { page, per_page } = params || {};

  const paramsList = {
    page: page || 1,
    per_page: per_page || 1000,
  };
  const queryString = createQueryParams(paramsList);

  return axiosConfig.get(
    `${GET_FAMILIES__URL}/aircraft-families${queryString ? `?${queryString}` : ""}`
  );
};

export const GetEngineFamilyService = async (params) => {
  const { page, per_page, search_by } = params || {};

  const paramsList = {
    page: page || 1,
    per_page: per_page || 1000,
    name: search_by,
  };

  const queryString = createQueryParams(paramsList);
  return axiosConfig.get(
    `${GET_FAMILIES__URL}/engine-families${queryString ? `?${queryString}` : ""}`
  );
};

export const GetEngineFamilyTypesService = async ({ id, per_page }) => {
  const queryString = createQueryParams({ id, per_page });

  const url = `${GET_FAMILIES__TYPES_URL}${queryString ? `?${queryString}` : ""}`;

  return axiosConfig.get(url);
};

export const DeleteAttachmentsService = async ({ slug, url }) => {
  return axiosConfig.delete(`${url ? url : DELETE_ATTACHEMENTS_URL}/${slug}`);
};

export const GetVendorsDropdownService = async (params) => {
  const { page, per_page, column, search_by } = params || {};

  const paramsList = {
    page: page || 1,
    per_page: per_page || 1000,
    column,
    search_by,
  };
  const queryString = createQueryParams(paramsList);

  return axiosConfig.get(
    `${CONFIG_VENDOR_URL}${queryString ? `?${queryString}` : ""}`
  );
};

export const GetBamUsersService = async (params) => {
  return axiosConfig.get(BAM_USERS_URL);
};

export const GetPNDropdownService = async (params) => {
  const { page, per_page, pn, graphFilter } = params || {};
  const { application_code } = graphFilter || {};
  const paramsList = {
    page: page || 1,
    per_page: per_page || 1000,
    pn,
    application_code: isArray(application_code)
      ? getStringFromArray(application_code)
      : application_code?.value,
  };
  const queryString = createQueryParams(paramsList);
  return axiosConfig.get(
    `${PN_DROPDOWN_URL}${queryString ? `?${queryString}` : ""}`
  );
};

export const GetRVDropdownService = async (params) => {
  const { page, per_page, rv } = params || {};
  const paramsList = {
    page: page || 1,
    per_page: per_page || 1000,
    repair_vendors: rv,
  };
  const queryString = createQueryParams(paramsList);
  return axiosConfig.get(
    `${RV_DROPDOWN_URL}${queryString ? `?${queryString}` : ""}`
  );
};

export const GetCustomerPNDropdownService = async (params) => {
  const { page, per_page, cmp_auto_key, pn } = params || {};
  const paramsList = {
    page: page || 1,
    per_page: per_page || 1000,
    CMP_AUTO_KEY: cmp_auto_key,
    pn,
  };
  const queryString = createQueryParams(paramsList);
  return axiosConfig.get(
    `${CUSTOMER_PN_DROPDOWN_URL}${queryString ? `?${queryString}` : ""}`
  );
};
